/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Promo_Holdings_RemainingInputs */



/**
* | output |
* | --- |
* | "{count} remaining" |
*
* @param {Promo_Holdings_RemainingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_holdings_remaining = /** @type {((inputs: Promo_Holdings_RemainingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Holdings_RemainingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} restante(s)`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} restante(s)`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} restante(s)`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} rimanente/i`)
	return /** @type {LocalizedString} */ (`${i?.count} remaining`)
});